window.addEventListener("load", function() { 
var addToCartPopup = document.getElementById('add-to-cart');
/* To sort cart items and remove quantity controls to avoid changing cart-items.liqud template */
if(window.location.pathname == '/cart') {
  jQuery(function(){
    /* To sort divs based on the price */
    jQuery.fn.sortDivs = function sortDivs() {
      $("> div", this[0]).sort(dec_sort).appendTo(this[0]);
      function dec_sort(a, b){ if($(b).attr('class') != 'Cart__Head hidden-phone') { return (parseFloat($(b).find('.CartItem__Price').html().replace("$",""))) < (parseFloat($(a).find('.CartItem__Price').html().replace("$",""))) ? -1 : 1; }}
    }
    $(".Cart__ItemList").sortDivs();
    /* To remove quantity controls for zero priced items */
    jQuery('.CartItem').each(function(){
      if(parseFloat($(this).find('.CartItem__Price').html().replace("$","")) == 0) {
        //jQuery(this).find('.QuantitySelector__CurrentQuantity').val();
        jQuery(this).find('.CartItem__Actions').html(jQuery(this).find('.QuantitySelector__CurrentQuantity').val());
        jQuery(this).find('.CartItem__Title a').attr('href','javascript:void(0)');
      }
    });
  });
}

/* Code for adding and managing the samples in cart - To be enabled in January */

if((window.location.pathname.indexOf("cart") != -1 || window.location.pathname.indexOf("checkout") != -1)) {
  var loader = $('<span class="promo-loader"><span style="position: absolute;width:100%;text-align:center;top:62%;">Checking for available promotions...</span></span>');
  var freeProduct = [4364960825484,31233467646092];
  var brushProduct = [4463607840908,31738779369612];
  var gwp149 = [4539868217484,32111432532108];
  var gwp199 = [4630861021324,32519916290188];
  var pageurl = window.location.pathname.indexOf("checkout") != -1 ? window.location.origin:window.theme.localeRootUrl;
  var giftPresent = 0;
  var lookPresent = 0;
  var brushPresent = 0;
  var brushFoundationArray = ["32166","32167","32168","32169","32170","30565","31518","31519","31520","31521","31522","18976","18985","19021","12638","12639","12640","12641","12642","12643","19420","19422","19424","19426","19428","30025","30027","30029","00824","00822","16489","16490","16488","16491","16492","10186","00823","00821","00820","00816","17409","17410","17318","17411","17412","15059","15060","18990","00840","00841","00837","00842","00838","00843","00859","13630","13631","13632","13633","13634","13635","13636","13637","13638","13639","11644","11645","30939","15948","15949","30943"];
  var brushPrimerArray = ["33555","33554","33553","31990","19788","19691","19685","14314","16095"];
  var foundationPresent = 0;
  var primerPresent = 0;
  
  var kabukiFoundationArray = ["30565","31518","31519","31520","31521","31522","18976","18985","19021","12638","12639","12640","12641","12642","12643","19420","19422","19424","19426","19428","30025","30027","30029","00824","00822","16489","16490","16488","16491","16492","10186","00823","00821","00820","00816","17409","17410","17318","17411","17412","18990","00840","00841","00837","00842","00838","00843","00859","13630","13631","13632","13633","13634","13635","13636","13637","13638","13639","11644","11645"];
  var kabukiBronzeArray = ["15943","31544","31543"];
  var kabukiProduct = [4166170247308,30290144100492];
  var kabukiPresent = 0;
  var kabukiFoundationPresent = 0;
  var kabukiBronzePresent = 0;  
  
  
  var count = 0;

  /* To check how many items are there in the cart and add the samples accordingly */
  $(document).ready(function(){
    $.ajax({
      url: pageurl+'/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        if(data.items.length > 0 ) {
          gwpQualifier(data);
          //brushQualifier(data);
          //looksgwpQualifier(data);
          newgwpQualifier(data);
          //kabukiQualifier(data);
        }
      }
    });
  });
  var gwpQualifier = function gwpQualifier(data) {
    var cartTotal = data.total_price;
    jQuery.each(data.items, function(key, value) {
      if(value.product_id == freeProduct[0]) { 
        giftPresent = value.quantity;
      }
      if(value.product_id != freeProduct[0]) { 
        count++;
      }
    });

    if(!giftPresent && count > 0) {
      $.ajax({
        url: 'https://apps.napoleonperdis.com/api/get-variant-details',
        data : { product_id:freeProduct[0]},
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if(data.qty > 0)
            addProduct(freeProduct[1],1);
        }
      });
    } else if (giftPresent && cartTotal <= 0) {
      clearCart();
    } else if (giftPresent > 1) {
      updateProduct(freeProduct[1],1);
    }

  }
  var looksgwpQualifier = function looksgwpQualifier(data) {
    var cartTotal = data.total_price;
    jQuery.each(data.items, function(key, value) {
      if(value.product_id == gwp149[0]) { 
        lookPresent = value.quantity;
      }
      if(value.product_id != gwp149[0]) { 
        count++;
      }
    });

    if(!lookPresent && count > 0) {
      $.ajax({
        url: 'https://apps.napoleonperdis.com/api/get-variant-details',
        data : { product_id:gwp149[0]},
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if(cartTotal >= 14900)
            addProduct(gwp149[1],1);
        }
      });
    } else if (lookPresent && cartTotal < 14900) {
      var removalData = {updates: {}};
      removalData.updates[gwp149[1]] = 0;
      clearProduct(removalData);
    } else if (lookPresent > 1) {
      updateProduct(gwp149[1],1);
    }

  }
  var newgwpQualifier = function newgwpQualifier(data) {
    var cartTotal = data.total_price;
    jQuery.each(data.items, function(key, value) {
      if(value.product_id == gwp199[0]) { 
        lookPresent = value.quantity;
      }
      if(value.product_id != gwp199[0]) { 
        count++;
      }
    });

    if(!lookPresent && count > 0) {
      $.ajax({
        url: 'https://apps.napoleonperdis.com/api/get-variant-details',
        data : { product_id:gwp199[0]},
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if(data.qty > 0)
            addProduct(gwp199[1],1,'popup');
        }
      });
    } else if (lookPresent && cartTotal <= 0) {
      clearCart();
    } else if (lookPresent > 1) {
      updateProduct(gwp199[1],1);
    }

  }
  var brushQualifier = function brushQualifier(data) {
    jQuery.each(data.items, function(key, value) {
      if(value.product_id == brushProduct[0]) { 
        brushPresent = value.quantity;
      }
      if(brushFoundationArray.indexOf(value.sku) != -1)
        foundationPresent = 1;
      if(brushPrimerArray.indexOf(value.sku) != -1)
        primerPresent = 1;
    });

    if(!brushPresent && foundationPresent == 1 && primerPresent == 1) {
      $.ajax({
        url: 'https://apps.napoleonperdis.com/api/get-variant-details',
        data : { product_id:brushProduct[0]},
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if(data.qty > 0)
            addProduct(brushProduct[1],1);
        }
      });
    } else if (brushPresent && (foundationPresent !=1 || primerPresent !=1)) {
      var removalData = {updates: {}};
      removalData.updates[brushProduct[1]] = 0;
      clearProduct(removalData);
    } else if (brushPresent > 1) {
      updateProduct(brushProduct[1],1);
    }

  }
  /* Kabuki brush qualifier method */
  var kabukiQualifier = function kabukiQualifier(data) {
    kabukiqty = 0;
    jQuery.each(data.items, function(key, value) {
      if(value.properties && value.properties['Note'] == 'Gift With Purchase') { 
        kabukiPresent = value.key;
        kabukiqty = value.quantity;
      }
      if(kabukiFoundationArray.indexOf(value.sku) != -1)
        kabukiFoundationPresent = 1;
      if(kabukiBronzeArray.indexOf(value.sku) != -1)
        kabukiBronzePresent = 1;
    });

    if(!kabukiPresent && kabukiFoundationPresent == 1 && kabukiBronzePresent == 1) {
      $.ajax({
        url: 'https://apps.napoleonperdis.com/api/get-variant-details',
        data : { product_id:kabukiProduct[0]},
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if(data.qty > 0)
            addProduct(kabukiProduct[1],1,"kabuki");
        }
      });
    } else if (kabukiPresent && (kabukiFoundationPresent !=1 || kabukiBronzePresent !=1)) {
      var removalData = {updates: {}};
      removalData.updates[kabukiPresent] = 0;
      clearProduct(removalData);
    } else if (kabukiqty > 1) {
      updateProduct(kabukiPresent,1);
    }

  }
  
  
  function parseQuantity(quantityArray) {
    var min = [];
    var maxresidue = [];
    for(i=0;i<=quantityArray.length/2;i += 2) {

      if(quantityArray[i] < quantityArray[i+1] ) {
        min.push(quantityArray[i]);
        maxresidue.push(quantityArray[i+1] - quantityArray[i]);
      }
      else if(quantityArray[i] == quantityArray[i+1] ) {
        min.push(quantityArray[i]);
      }
      else {
        min.push(quantityArray[i+1]);
        maxresidue.push(quantityArray[i] - quantityArray[i+1]);
      }
    }
    if(quantityArray.length%2 == 1) {
      maxresidue.push(quantityArray[quantityArray.length-1]);
    }
    /* alert(quantityArray);
      alert(maxresidue);
      alert(min.reduce((a, b) => a + b, 0)); */
    $.each(arr,function(){sum+=parseFloat(this) || 0;});
    if(maxresidue.length > 1 )
      return sum+parseQuantity(maxresidue);
    return sum;
  }

  function addProduct(variantid,qty,displayType = '') {
    var properties = null;
    if(displayType != 'popup' && displayType != 'kabuki')
      showloader();
    if(displayType == 'kabuki') {
      properties = {
        quantity: qty,
        id: variantid,
        properties: {
          'Note': 'Gift With Purchase'
        }
      };
    }
    else  {
      properties = {
        quantity: qty,
        id: variantid,
        properties: {
          'Note': 'A Free Gift For You'
        }
      };
    }
    $.ajax({
      url: pageurl+'/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: properties,
      success: function(data) {
        if(displayType == 'popup' || displayType == 'kabuki' && typeof Shopify.Checkout == 'undefined') {
          jQuery('#add-to-cart .p-img').attr('src',data.featured_image.url);
          jQuery('#add-to-cart .p-name').html(data.title);
          jQuery('#add-to-cart .product_qty_price').hide();
          jQuery('#add-to-cart .view_cart').hide();
          jQuery('#add-to-cart .continue_shopping').css('float','none');
          jQuery('#add-to-cart .continue_shopping').css('margin','0 auto');
          addToCartPopup.style.display='block';
          if(data.product_id == '4630861021324') {
            jQuery('#add-to-cart .title').html('FREE GIFT<br/><h4 style="margin-top:12px;font-size: 12px;line-height: 19px;">Thank you for shopping with us. Because SPF is non-negotiable, we’re sending you our sunscreen with your order. Enjoy!</h4>');
          }
        } else {
          location.href = window.location.href;
        }
      },
      error: function (jqXHR, exception) {
        location.href = window.location.href;
      }
    });
  }
  function updateProduct(variantid,qty) {
    showloader();
    $.ajax({
      url: pageurl+'/cart/change.js',
      type: 'POST',
      dataType: 'json',
      data: {
        quantity: qty,
        id: variantid
      },
      success: function(data) {
        location.href = window.location.href;
      },
      error: function (jqXHR, exception) {
        location.href = window.location.href;
      }
    });
  }
  function clearProduct(removalData) {
    showloader();
    $.post(
      pageurl+'/cart/update.js',
      removalData,
      null,
      'json'
    ).done(function(){
      location.href = window.location.href;
    }).fail(function(){
      location.href = window.location.href;
    });
  }
  function clearCart() {
    showloader();
    $.post(
      pageurl+'/cart/clear.js',
      'json'
    ).done(function(){
      location.href = window.location.href;
    }).fail(function(){
      location.href = window.location.href;
    });
  }

  function showloader() {
    loader.insertAfter('body');
    showOverlay();
  }
  function hideOverlay() {
    $('.PageOverlay').css('opacity',0);
    $('.PageOverlay').css('visibility','hidden');
  }
  function showOverlay() {
    $('.PageOverlay').css('opacity',0.5);
    $('.PageOverlay').css('visibility','visible');
  }
}
/* To cycle the messages shown in AnnouncementBar */
/* var text = ["Free Sample with every order.","<strong>Your Gift:</strong> Receive 9-Piece Gift With Any Purchase $149+", "Beauty Now, Pay Later. Shop With Afterpay.", "Free shipping within Australia on orders $75 and over."]; */
var text = ["Free Sample with every order.", "Beauty Now, Pay Later. Shop With Afterpay.", "Free shipping within Australia on orders $75 and over."];
var counter = 0;
var elem = document.getElementsByClassName("AnnouncementBar__Content")[0];
var inst = setInterval(change, 5000);

function change() {
  if(elem) {  
    elem.innerHTML = text[counter];
    counter++;
    if (counter >= text.length) {
      counter = 0;
      // clearInterval(inst); // uncomment this if you want to stop refreshing after one cycle
    }
  }
}
});